import React from 'react';
import { CheckIcon, MailIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { contactPerks } from '../data/contact';
import { contactEmail } from '../data/siteLinks';
export function ContactSection() {
  const revealRef = useScrollReveal();
  return <section id="kontakt" ref={revealRef} aria-labelledby="kontakt-nadpis" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8" data-id="element-49" data-mp="2pj9uiigu30hv">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16 items-start" data-id="element-50" data-mp="3i7xn6z3wws5g">
        <div className="reveal lg:col-span-2" data-id="element-51" data-mp="34862ygmsyfj0">
          <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-4" data-id="element-52" data-mp="347d5655tn0d0">
            Kontakt
          </p>
          <h2 id="kontakt-nadpis" className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-apple-black mb-5" data-id="element-53" data-mp="1sshflo5mzeho">
            Postavíme váš ďalší produkt?
          </h2>
          <p className="text-lg text-apple-gray leading-relaxed mb-8" data-id="element-54" data-mp="7ld2ulk3sa40">
            Popíšte nám nápad. Do 24 hodín sa ozveme s návrhom riešenia a odhadom ceny.
          </p>
          <ul className="space-y-3 mb-8" data-id="element-55" data-mp="gmutuyz1tw7h">
            {contactPerks.map(perk => <li key={perk} className="flex items-center gap-3 text-apple-black font-medium" data-id="element-56" data-mp="gki1drvo03g6">
                <span className="w-6 h-6 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-57" data-mp="cnc51s43x0zd">
                  <CheckIcon className="w-3.5 h-3.5 text-apple-blue" aria-hidden="true" data-id="element-58" data-mp="llxl9gm3w3wz" />
                </span>
                {perk}
              </li>)}
          </ul>
          <a href={`mailto:${contactEmail}`} className="inline-flex items-center gap-2 min-h-[44px] text-apple-blue font-semibold hover:underline" data-id="element-59" data-mp="10cwp6ebzy4a8">
            <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-60" data-mp="19bryw0e91wia" />
            {contactEmail}
          </a>
        </div>

        <div className="reveal reveal-delay-1 lg:col-span-3 bg-white rounded-3xl border border-gray-200 shadow-sm p-6 md:p-10" data-id="element-61" data-mp="14akpxy0dera1">
          <ContactForm idPrefix="kontakt" source="projekt" submitLabel="Odoslať dopyt" data-id="element-62" data-mp="6xknaydl04y9" />
        </div>
      </div>
    </section>;
}